import { toCssColor, DefaultCategoryColor } from '../utils/color-utils';
import * as calendarConsts from '../constants/calendar-constants';

import moment from 'moment';
import _ from 'lodash';

export const getEventsOfYear = (momentDateObj, calendarEventsFromBackend) => {
  const [dayObjFirst, dayObjLast] = [momentDateObj.clone().local(true).startOf('month'), momentDateObj.clone().local(true).endOf('month')];
  const result = getEventsByDates(dayObjFirst, dayObjLast, calendarEventsFromBackend, calendarConsts.YEAR_MODE);

  return result;
};

export const getEventsOfMonth = (year, month, day, calendarEventsFromBackend) => {
  const [dayObjFirst, dayObjLast] = [moment([year, month, day]).local(true), moment([year, month, day, 23, 59, 59, 999]).local(true)];
  let result = getEventsByDates(dayObjFirst, dayObjLast, calendarEventsFromBackend, calendarConsts.MONTH_MODE);

  return result.sort((a, b) => b.durationInMins - a.durationInMins);
};

const getEventsByDates = (dayObjFirst, dayObjLast, calendarEventsFromBackend, mode) => {
  const result = [];

  calendarEventsFromBackend &&
    calendarEventsFromBackend.forEach((element) => {
      const [start, end] = [
        moment(element.start).utcOffset(element.timeZoneOffsetHours).local(),
        moment(element.end).utcOffset(element.timeZoneOffsetHours).local(),
      ];

      if ((dayObjFirst <= start && start <= dayObjLast) || (dayObjFirst <= end && end <= dayObjLast) || (start <= dayObjFirst && end >= dayObjLast)) {
        let positions = null;
        const eventDuration = moment.duration(end.diff(start)).asMinutes();
        const diffFirstStart = moment.duration(start.diff(dayObjFirst)).asMinutes();
        const diffLastEnd = moment.duration(end.diff(dayObjLast)).asMinutes();

        // finding short events here
        if (calendarConsts.isCustomMode(mode)) {
          let startMins = diffFirstStart;
          let endMins = moment.duration(end.diff(dayObjFirst)).asMinutes();

          startMins = startMins < 0 ? 0 : startMins;
          endMins = endMins < 0 ? 0 : endMins > calendarConsts.MinutesInDay ? calendarConsts.MinutesInDay : endMins;

          const height = endMins - startMins;

          if (height !== 0 && height <= calendarConsts.MinutesInDay) {
            // calendarConsts.MinutesInDay less then day
            positions = {
              start: startMins,
              end: endMins,
              height: height,
              zIndex: 10,
              width: 100, //percents
              left: 0, //percents
            };
          }
        }

        const cols = {
          cellKey: element.id + '_mode_' + mode + '_in_' + dayObjFirst.format('MM-DD-YYYY'),
          cellDate: dayObjFirst,
          content: element.subject,
          start: element.start,
          continousStart: start >= dayObjFirst && dayObjLast <= end,
          continousMiddle: start <= dayObjFirst && end >= dayObjLast,
          continousLast: start <= dayObjFirst && end <= dayObjLast,
          durationInMins: eventDuration,
          positions: positions,
          diffFirstStart: diffFirstStart,
          diffLastEnd: diffLastEnd,
          start: start.format(), //local string date
          end: end.format(), //local string date
          startObj: start, //local date object
          endObj: end, //local date object
          isCheckedRecurrent: !!element.recurrenceObject,
        };

        result.push({ ...element, ...cols });
      }
    });

  return result;
};

export const getModeEvents = (modeDays, calendarEventsFromBackend, mode) => {
  if (!mode || !modeDays || modeDays.length === 0 || !calendarEventsFromBackend) return null;

  let start = modeDays[0].dateObjStart.local(true).clone();
  let end = modeDays[modeDays.length - 1].dateObjStart.local(true).clone().endOf('day');

  let headEventsArray = getEventsByDates(start, end, calendarEventsFromBackend, mode);
  headEventsArray = headEventsArray.filter((ev) => ev.durationInMins >= calendarConsts.MinutesInDay) || [];
  headEventsArray = _.orderBy(headEventsArray, (obj) => [obj.start, obj.end], ['asc']);

  const dayEventsRusult = [];
  modeDays.forEach((day) => {
    start = day.dateObjStart.local(true).clone();
    end = day.dateObjStart.local(true).clone().endOf('day');

    let eventsPerDay = getEventsByDates(start, end, calendarEventsFromBackend, mode);
    eventsPerDay = eventsPerDay.filter((ev) => ev.positions && ev.durationInMins <= calendarConsts.MinutesInDay) || [];
    const resultPerDay = recalcPositionEvents(eventsPerDay);
    const dayEventsObj = { ...day, ...{ dayEvents: resultPerDay } };

    dayEventsRusult.push(dayEventsObj);
  });

  return { headEvents: headEventsArray, dayShortEvents: dayEventsRusult };
};

// #region Short events algorithm

const collidesWith = (ev, withEv) => {
  const startMins = ev.positions.start;
  const endMins = ev.positions.end;

  const withStart = withEv.positions.start;
  const withEnd = withEv.positions.end;

  if (
    (startMins > withStart && withEnd < endMins) ||
    (withStart > startMins && endMins < withEnd) ||
    (startMins < withEnd && withEnd < endMins) ||
    (startMins < withStart && withStart < endMins)
  ) {
    return true;
  }

  return false;
};

const expandEvent = (ev, iColumn, columns) => {
  let colSpan = 1;
  _.forEach(
    columns.filter((v, index) => index > iColumn),
    (col) => {
      _.forEach(col, (ev1) => {
        if (collidesWith(ev1, ev)) {
          return colSpan;
        }
      });
      colSpan++;
    },
  );
  return colSpan;
};

const packEvents = (columns) => {
  _.forEach(columns, (col, iColumn) => {
    _.forEach(col, (ev, evIndex) => {
      const numColumns = col.length;
      //const colSpan = expandEvent(ev, iColumn, col);
      const colSpan = 0;
      const left = Math.round((evIndex * 100) / numColumns);
      const width = Math.round(100 / numColumns);
      ev.positions.left = left;
      ev.positions.width = width;
    });
  });

  return columns;
};

const recalcPositionEvents = (events) => {
  if (events && events.length > 1) {
    events = _.orderBy(events, (obj) => [obj.start, obj.end], ['asc']);

    let columns = [];
    _.forEach(events, (ev) => {
      let placed = false;
      var breakException = {};
      try {
        _.forEach(columns, (col) => {
          if (!collidesWith(col[col.length - 1], ev)) {
            col.push(ev);
            placed = true;
            throw breakException;
          }
        });
      } catch (ex) {
        if (ex !== breakException) throw ex;
      }

      if (!placed) {
        columns.push([ev]);
      }
    });

    if (columns.length > 0) {
      columns = packEvents(columns);
    }
  }

  return events;
};

// #endregion Short events algorithm

// #region Sidebar checkboxes data

export const getFilters = () => {
  const result = [];

  Object.keys(calendarConsts.CALENDAR_FILTERS).map(function (k) {
    let obj = calendarConsts.CALENDAR_FILTERS[k];

    return result.push({
      id: obj.value,
      categoryName: obj.label,
      checked: obj.checked,
      title: obj.title,
      color: obj.color,
    });
  });

  return result;
};

export const getCategoriesWithSetting = (calendarCategories, categorySettings) => {
  const result = [];

  calendarCategories &&
    calendarCategories.map(function (category, k) {
      const setting =
        (categorySettings &&
          categorySettings.filter((obj) => {
            return obj.calendarCategoryId === category.id;
          })) ||
        null;

      const currentSetting = !!setting && setting.length === 1 ? setting[0] : null;

      const additionalProps = {
        title: category.categoryName,
        checked: !!currentSetting && currentSetting.displayByDefault,
        sendEmails: !!currentSetting && currentSetting.sendEmails,
        displayByDefault: !!currentSetting && currentSetting.displayByDefault, //used on edit category
        settingId: !!currentSetting && currentSetting.id,
        color: category.color ? toCssColor(category.color) : DefaultCategoryColor,
      };

      result.push({ ...category, ...additionalProps });
    });

  //default uncategorized checkbox for categories with id = null or where no category property inside object
  result.push({
    id: calendarConsts.GUID_EMPTY,
    categoryName: calendarConsts.UNCATEGORIZED,
    title: calendarConsts.UNCATEGORIZED,
    checked: false,
    color: DefaultCategoryColor,
  });

  return result;
};

export const getCategoryWithSetting = (category, setting) => {
  return {
    id: category.id,
    title: category.categoryName,
    categoryName: category.categoryName,
    color: category.color,
    settingId: setting?.id,
    displayByDefault: setting?.displayByDefault,
    checked: setting?.displayByDefault,
  };
};

// #endregion Sidebar checkboxes data

export const getDayTimeSteps = () => {
  const countOfTimeLines = Math.round(calendarConsts.MinutesInDay / calendarConsts.CustomModeTimeStep); //count of time row intervals per day 24(hours) * 60(mins) / defaultTimeStep

  let time = moment().startOf('day');
  const rows = [];

  for (var i = 0; i < countOfTimeLines; i++) {
    rows.push({ key: 'min-' + i * calendarConsts.CustomModeTimeStep, val: time.format('hh:mm a'), mins: i * calendarConsts.CustomModeTimeStep });
    time = time.add(calendarConsts.CustomModeTimeStep, 'minutes');
  }
  return rows;
};

export const getModeDays = (dates, mode) => {
  const { navigationDate, dateFrom } = dates;
  const result = [];

  switch (mode) {
    case calendarConsts.DAY_MODE:
      result.push({
        day: navigationDate.format('dddd'),
        date: navigationDate.date(),
        selected: false,
        dateObjStart: navigationDate.clone().startOf('day').clone(),
        dateKey: navigationDate.format('MM-DD-YYYY'),
      });
      break;
    case calendarConsts.WEEK_MODE:
    case calendarConsts.TIMELINE_MODE:
      const selectedOfweek = navigationDate.day();
      let start = dateFrom.startOf('day').clone();
      const count = mode === calendarConsts.WEEK_MODE ? calendarConsts.WeekModeDays : calendarConsts.TimelineModeDays;

      for (let i = 0; i < count; i++) {
        let dayOfweek = start.day();
        result.push({
          day: navigationDate._locale._weekdaysShort[dayOfweek],
          date: start.date(),
          selected: dayOfweek === selectedOfweek,
          dateObjStart: start.clone(),
          dateKey: start.format('MM-DD-YYYY'),
        });
        start = start.add(1, 'day').clone();
      }
      break;
  }

  return result;
};

export const getCalendarHeaderMonthItems = (momentObj) => {
  const start = 0;
  const end = 12;
  const current = momentObj.clone();
  const localeData = momentObj.localeData();
  const months = [];

  for (let i = start; i < end; i++) {
    current.month(i);
    months.push({ id: i, name: localeData.monthsShort(current) });
  }

  return months;
};

export const getCalendarHeaderYearItems = (momentObj) => {
  const year = momentObj.clone().year();
  const yearsBeforeOrAfter = 10;

  const years = Array.from({ length: 2 * yearsBeforeOrAfter }, (_, i) => year - (yearsBeforeOrAfter - (i + 1)));
  return years;
};
